<div *ngIf="showSettings" class="back-drop"></div>
<div class="plan-container">
    <header>
        <nav mat-tab-nav-bar backgroundColor="primary" *ngIf="results && selectedResult">
            <!-- <a mat-tab-link *ngFor="let nav of results"
                (click)="activeLink = nav"
                [active]="activeLink == nav"> {{nav.desc}} 
            </a> -->
            <button mat-button *ngFor="let result of results; let i = index" class="pointer header-nav header-nav-item m-lr3" [ngClass]="result.id===selectedResult.id?'header-nav-item__selected':''" (click)="selectResult(result, 'headernav')">
                <span *ngIf="showHeaderAnimation" [@AnimateContentFadeInOut1]>{{result.desc}}</span>                
            </button> 
            <!-- <div class="flex-col-end flex-1 m-r25">
                <div class="flex-row-container">
                    <div class="flex-col-center">
                        <div class="flex-row-container m-t3"  *ngIf="clientName"><mat-icon class="font18" style="color: var(--white)">person</mat-icon><span style="color: var(--white)">{{clientName | uppercase}}</span></div>
                        <div class="flex-row-container"  *ngIf="planName"><span class="font16" style="color: var(--themeSecondaryContrast);">{{planName}}</span><mat-icon class="pointer" style="font-size: 16px; color: var(--themeSecondaryContrast)">edit</mat-icon></div>                
                    </div>
                    <button style="height:35px" class="m-t7 m-l20" mat-raised-button color="accent" (click)="savePlan()">Save Plan</button>
                </div>
            </div>             -->
            <div class="flex-col-end flex-1 m-r15">
                <div class="flex-col-center"> 
                    <div class="flex-row-container m-t3 text-truncate"  *ngIf="clientName"><mat-icon class="font20" style="color: var(--white)">person</mat-icon><span style="color: var(--white)">{{clientName | uppercase}}</span></div>
                    <div class="flex-row-container text-truncate"  *ngIf="planName"><span class="font16" style="color: var(--themeSecondaryContrast);">{{planName}}</span><mat-icon class="pointer" style="font-size: 16px; color: var(--themeSecondaryContrast)" (click)="editPlan()">edit</mat-icon></div>                
                </div>                
            </div>   
            <!-- <div class="flex-col-center m-r15">
                <button [disabled]="isPlanDirty" style="height:35px; color: var(--neutralPrimary)" class="m-t8 m-l20" mat-raised-button color="accent" (click)="savePlan()">Save Plan</button>
            </div>  -->
            <div class="flex-col-end m-r5">
                <mat-icon class="pointer" style="font-size: 20px; color: var(--white)" (click)="showHideSettings()">settings</mat-icon>
            </div> 
        </nav>        
    </header>
    <mat-progress-bar class="progress-bar-buffer progress-bar-fill" *ngIf="showProgress" mode="indeterminate"></mat-progress-bar>   
    <!-- <main  class="m-tb10 m-lr25 flex-col-container" @AnimateSlides>
        <section *ngIf="!showAnimation" class="p-10" >
            <gp-component-container [ComponentType]="componentType">
                Loading...
            </gp-component-container>                                      
        </section>
        <div *ngIf="showAnimation"  class="flex-1"></div>
        <section #animationBox *ngIf="showAnimation"  class="pageBox">
            Clients & Relationship
        </section>
    </main> -->

    <main  class="m-tb10 m-lr3 flex-row-container" #mainSection>
        <button class="control" *ngIf="showContentAnimation" (click)="onSideNavClick('left')">
            <span class="arrow left"></span>
            <!-- <mat-icon style="font-size: 18px">keyboard_arrow_left</mat-icon> -->
        </button>
        <section class="flex-1" [ngClass]="componentType !== 'CASHFLOWSTABLE'?'p-lr20':''" *ngIf="showContentAnimation" @AnimateContentFadeInOut>
            <!-- <mat-tab-group mat-align-tabs="center" [color]="'accent'">
                <mat-tab  *ngFor="let result of results; let i = index" [label]="result.desc">{{result.desc}}</mat-tab>
            </mat-tab-group>  -->
            <nav class="m-t5 m-b5" mat-tab-nav-bar mat-align-tabs="center" *ngIf="subResults && selectedSubResult">
                <a mat-button *ngFor="let subResult of subResults; let i = index" class="pointer" [ngClass]="subResult.id===selectedSubResult.id?'sub-header-nav-item__selected':''" (click)="selectSubResult(subResult)">
                    <span>{{subResult.desc}}</span>                
                </a> 
            </nav>  
            <!-- <gp-component-container lass="m-t10 " [SaveId]="saveId" (onSave)="loadResult()" *ngIf="componentType" [ComponentType]="componentType" ></gp-component-container> -->
            <gp-component-container lass="m-t10 " *ngIf="componentType" [ComponentType]="componentType" >
                Loading...
            </gp-component-container>
        </section>   
        <button class="control" *ngIf="showContentAnimation" (click)="onSideNavClick('right')">
            <span class="arrow right"></span>
            <!-- <mat-icon style="font-size: 18px">keyboard_arrow_left</mat-icon> -->
        </button>      
        <div class="flex-1" *ngIf="showBoxAnimation" ></div>
        <section #animationBoxEl *ngIf="showBoxAnimation"  class="animationBoxContainer">
            <!-- <div class="animationBox">
                Clients & Relationship
            </div> -->
        <div class="box font9 p-50 flex-row-center" >{{selectedResultSection.desc}}</div>        
            
            
        </section>

        <div  class="settings-pos" *ngIf="showSettings" [@ShowHideSettings]> <!-- Settings Start -->
            <gp-settings (hideSettings)="showHideSettings()"></gp-settings>
        </div> <!-- Settings End -->
        
    </main>

    <!-- <footer>
        <mat-accordion>
            <mat-expansion-panel [expanded]='footerExpanded' class="footer" (click)="footerExpandCollapse()">
                <mat-expansion-panel-header>
                    <mat-panel-title style="color:var(--black)">
                        <span class="m-r5 font20">{{selectedResultSection?selectedResultSection.desc:''}}</span>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>          
                <nav *ngIf="resultSections && resultSections.length>0 && selectedResultSection" mat-tab-nav-bar class=""  [@AnimateFooterStagger]="resultSections.length">
                    <mat-card  *ngFor="let resultSec of resultSections; let i = index" class="mat-card-center footer-nav-item pointer m-lr3" [ngClass]="resultSec.id===selectedResultSection.id?'footer-nav-item__selected':''"  (click)="selectResultSection(resultSec)">
                        <mat-card-content class="ip-center">
                                <span>{{resultSec.desc}}</span>                    
                        </mat-card-content>
                    </mat-card>                                     
                </nav>                
            </mat-expansion-panel>
        </mat-accordion>
    </footer> -->



    <footer class="footer p-l10">
        
                <nav *ngIf="resultSections && resultSections.length>0 && selectedResultSection" mat-tab-nav-bar class=""  [@AnimateFooterStagger]="resultSections.length">
                    <mat-card  *ngFor="let resultSec of resultSections; let i = index" class="mat-card-center footer-nav-item pointer m-lr5" [ngClass]="resultSec.id===selectedResultSection.id?'footer-nav-item__selected':''"  (click)="selectResultSection(resultSec)">
                        <mat-card-content class="ip-center">
                                <span>{{resultSec.desc}}</span>
                                <!-- <img mat-card-image  id={{template.id}} src="../../../assets/RCMTemplate.png" class="p-lr15" class={{template.id}} width="250" height="150"> -->                                
                        </mat-card-content>
                    </mat-card>                                     
                </nav>                
        
        
    </footer>
</div>





<!-- <div class="m-l15">
    <button class="control">
        <span class="arrow right"></span>        
    </button>
</div> -->

<!-- #FF9800 -->

